<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>
<div class="mainContainer">
    <app-menu selectedItem="cockpit" class="menu" [class.open]="mobileMenuOpen"></app-menu>

    <div class="content" [class.closed]="mobileMenuOpen">
        <h1>Willkommen im Kreditportal der VHV</h1>

        <div class="outerDash">
            @for (tile of tiles; track tile; let i = $index) {
                <elem-dashboard-item [itemDTO]="tile"></elem-dashboard-item>
            }
        </div>

        @if (numMsgs > 1) {
            <h1>Sie haben {{ numMsgs }} neue Benachrichtigungen</h1>
        } @else if (numMsgs === 1) {
            <h1>Sie haben eine neue Benachrichtigung</h1>
        }

        @for (notification of notifications; track notification) {
            <elem-msg-line [notification]="notification"></elem-msg-line>
        }
    </div>
</div>
